"use client";

import AnnouncementBarProviderBase from "@stadium/shared/src/contexts/announcement-bar";

import { useFlags } from "@stadium/services/launch-darkly";
import { useWorkspaceContext } from "@stadium/hooks/lib/workspace";

import { appGenericAnnouncementBarFlag } from "@stadium/services/launch-darkly/constants";
import { isAppGenericAnnouncementBarFlagEnabled } from "@stadium/ui/src/helpers/app-generic-banner";

import { DASHBOARD } from "@stadium/constants";

const AnnouncementBarProvider = ({ children }) => {
  const { [appGenericAnnouncementBarFlag]: appGenericAnnouncementBarFlagValue } = useFlags();
  const { isActivePackageUser } = useWorkspaceContext();

  const flagEnabled = isAppGenericAnnouncementBarFlagEnabled(
    appGenericAnnouncementBarFlagValue,
    DASHBOARD,
    isActivePackageUser,
  );

  return (
    <AnnouncementBarProviderBase appGenericAnnouncementBarFlagEnabled={flagEnabled}>
      {children}
    </AnnouncementBarProviderBase>
  );
};

export default AnnouncementBarProvider;
